import { create } from 'zustand';
import { api } from '../lib/api.js';
import { subscribeStatus } from '../lib/realtime.js';

let realtimeUnsub = null;

export const useStore = create((set, get) => ({
  episodes: [],
  episodesLoading: false,
  topics: [],
  toasts: [],
  jobs: { ingest: [], transcribe: [], analyze: [], render: [], publish: [] },

  // --- Episodes ---
  loadEpisodes: async () => {
    set({ episodesLoading: true });
    try {
      const data = await api.listEpisodes();
      set({ episodes: data.items, episodesLoading: false });
    } catch (err) {
      get().toast(err.message, 'err');
      set({ episodesLoading: false });
    }
  },

  upsertEpisode: (ep) => set((state) => {
    if (!ep || !ep.id) return state;
    const idx = state.episodes.findIndex((e) => e.id === ep.id);
    if (idx === -1) return { episodes: [ep, ...state.episodes] };
    const copy = [...state.episodes];
    copy[idx] = { ...copy[idx], ...ep };
    return { episodes: copy };
  }),

  removeEpisode: (id) => set((state) => ({
    episodes: state.episodes.filter(e => e.id !== id)
  })),


  // --- Topics ---
  loadTopics: async () => {
    try {
      const data = await api.topics();
      set({ topics: data.items });
    } catch (err) {
      get().toast(err.message, 'err');
    }
  },

  // --- Jobs ---
  loadJobs: async () => {
    try {
      const jobs = await api.jobs();
      set({ jobs });
    } catch {}
  },

  // --- Realtime ---
  startRealtime: () => {
    if (realtimeUnsub) return;
    realtimeUnsub = subscribeStatus({
      onEpisode: (ep) => get().upsertEpisode(ep),
      onEpisodeDelete: (id) => get().removeEpisode(id),
      onRenderJob: () => get().loadJobs(),
      onPublishJob: () => get().loadJobs(),
    });
  },
  stopRealtime: () => {
    if (realtimeUnsub) {
      realtimeUnsub();
      realtimeUnsub = null;
    }
  },

  // --- Toasts ---
  toast: (msg, kind = 'info') => {
    const id = Math.random().toString(36).slice(2);
    set((state) => ({ toasts: [...state.toasts, { id, msg, kind }] }));
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, 4000);
  },
  dismissToast: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
